import { addDomainToYup } from './domain';

export * from './domain';

export function initYupExtensions() {
    addDomainToYup();
}
